import styled from 'styled-components';
import { SEMANTIC_COLORS } from '@/constant/unit/color';
export const S = {
    PopupBody: styled.div `
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex-shrink: 0;

    width: calc(100% - 30px);
    height: calc(100% - 150px);
    padding: 20px 15px;

    overflow-y: auto;
    border-bottom: 1px solid rgb(93 134 90 / 50%);
  `,
    PopupBodySection: styled.div `
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
  `,
    PopupSectionGap: styled.div `
    flex-shrink: 0;
    width: 100%;
    height: 20px;
  `,
    PopupBodyTitle: styled.div `
    margin-bottom: 10px;
    font-size: 18px;
    font-weight: 500;
    color: ${SEMANTIC_COLORS.DEFAULT_TITLE};
  `,
    PopupBodyLayoutGrid: styled.div `
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    row-gap: 22px;
    column-gap: 22px;
  `,
    PopupBodyNotes: styled.div `
    margin-top: 20px;

    font-size: 16px;
    line-height: 23px;
    color: ${SEMANTIC_COLORS.DEFAULT_TEXT};
    opacity: 0.7;
  `,
    PopupFooterWithoutNotes: styled.div `
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 103px;
  `,
    PopupFooterWithNotes: styled.div `
    position: relative;

    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 103px;
  `,
    PopupFooterNotes: styled.div `
    position: absolute;
    top: 10px;
    right: 30px;
    font-size: 16px;
    font-weight: 500;
    line-height: 23px;

    color: ${SEMANTIC_COLORS.DEFAULT_TEXT};
    opacity: 0.7;
  `,
};
